import { Component, OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})

export class GalleryComponent extends SeoAwareBaseComponent implements OnInit {
  public interiorImages: any[] = [
    { url: '/assets/images/gallery/interior/1.jpg' },
    { url: '/assets/images/gallery/interior/2.jpg' },
    { url: '/assets/images/gallery/interior/3.jpg' },
    { url: '/assets/images/gallery/interior/4.jpg' },
    { url: '/assets/images/gallery/interior/5.jpg' },
    { url: '/assets/images/gallery/interior/6.jpg' }
  ];
  public exteriorImages: any[] = [
    { url: '/assets/images/gallery/exterior/3.jpg' },
    { url: '/assets/images/gallery/exterior/4.jpg' },
    { url: '/assets/images/gallery/exterior/5.jpg' },
    { url: '/assets/images/gallery/exterior/6.jpg' },
    { url: '/assets/images/gallery/exterior/7.jpg' },
    { url: '/assets/images/gallery/exterior/8.jpg' },
    { url: '/assets/images/gallery/exterior/10.jpg' },
    { url: '/assets/images/gallery/exterior/11.jpg' }
  ];

  public apImages: any[] = [
    { url: '/assets/images/gallery/ap/1.jpg' },
    { url: '/assets/images/gallery/ap/2.jpg' },
    { url: '/assets/images/gallery/ap/3.jpg' },
    { url: '/assets/images/gallery/ap/4.jpg' },
    { url: '/assets/images/gallery/ap/5.jpg' },
    { url: '/assets/images/gallery/ap/6.jpg' },
    { url: '/assets/images/gallery/ap/7.jpg' },
    { url: '/assets/images/gallery/ap/8.jpg' },
    { url: '/assets/images/gallery/ap/10.jpg' },
    { url: '/assets/images/gallery/ap/12.jpg' },
    { url: '/assets/images/gallery/ap/13.jpg' },
    { url: '/assets/images/gallery/ap/14.jpg' },
    { url: '/assets/images/gallery/ap/15.jpg' },
    { url: '/assets/images/gallery/ap/16.jpg' },
    { url: '/assets/images/gallery/ap/17.jpg' },
    { url: '/assets/images/gallery/ap/18.jpg' },
    { url: '/assets/images/gallery/ap/19.jpg' },
    { url: '/assets/images/gallery/ap/20.jpg' },
    { url: '/assets/images/gallery/ap/21.jpg' },
    { url: '/assets/images/gallery/ap/22.jpg' },
    { url: '/assets/images/gallery/ap/23.jpg' },
    { url: '/assets/images/gallery/ap/24.jpg' },
    { url: '/assets/images/gallery/ap/25.jpg' },
    { url: '/assets/images/gallery/ap/26.jpg' },
    { url: '/assets/images/gallery/ap/27.jpg' },
    { url: '/assets/images/gallery/ap/28.jpg' },
    { url: '/assets/images/gallery/ap/29.jpg' },
    { url: '/assets/images/gallery/ap/30.jpg' }
  ];

  constructor(
    public injector: Injector
  ) {
    super(injector);

    this.interiorImages.forEach((image, index) => {
      image.width_320_url = image.url;
      image.width_560_url = image.url;
    });
    this.exteriorImages.forEach((image, index) => {
      image.width_320_url = image.url;
      image.width_560_url = image.url;
    });
    this.apImages.forEach((image, index) => {
      image.width_320_url = image.url;
      image.width_560_url = image.url;
    });
  }

  ngOnInit(): void {
    this.setTitle('Viața ta la Romanescu Park Residence');

    this.setMetaDescription(`
      Iată câteva imagini care îți arată cât de frumos va fi să locuiești la Romanescu Park Residence -
      pentru că e întotdeauna minunat să fii aproape de natură, în mijlocul unui complex rezidențial
      de calitate
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/downtown-life/gallery.component.ts